import React from "react";

import { minRatio } from "../util/Constants";

interface Props {
  ratio: number;
  scale: number;
  left: number;
}

const BrowserNotice = (props: Props) => {
  const { ratio, scale, left } = props;

  const isShown = ratio >= minRatio;

  const style = {
    display: isShown ? "block" : "none",
    width: window.innerWidth / scale,
    left: `${left}px`,
  };

  return (
    <div className="browser-notice" style={style}>
      <div className="browser-notice-container">
        This browser is no longer supported.
        <br />
        Please update to MS IE Edge or use Google Chrome.
      </div>
    </div>
  );
};

export default BrowserNotice;
